import React, { useState } from "react";
import { Divider, IconButton, Menu, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { t } from "i18next";

function CoreViewLists({ value, text = null }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const colorPrimary = useSelector((state) => state.app.primaryColor);

  return (
    <div>
      <Tooltip title={t("Visualize")} disableHoverListener={value.length === 0}>
        <span>
          <IconButton
            className="w-10 h-10 font-sans "
            onClick={(e) => setAnchorEl(e.currentTarget)}
            disabled={value.length === 0}
          >
            <p
              className="font-medium"
              style={{
                color: value.length !== 0 ? colorPrimary : "lightgrey ",
                fontSize: " 0.875rem",
              }}
            >
              {value.length}
            </p>
          </IconButton>
        </span>
      </Tooltip>
      <div>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <div className="px-4">
            <p className="font-bold m-4">{text}</p>
            <Divider />
            {value?.map((el, i) => (
              <p key={i} className="m-4">
                {el?.name || el?.description || el?.studio?.name}
              </p>
            ))}
          </div>
        </Menu>
      </div>
    </div>
  );
}

export default CoreViewLists;
